module.exports = __webpack_public_path__ + "static/media/homepage-implement.d40ac22b.png";